<script setup lang="ts">
/* CONFIG */
import { textConfig } from '@/components/text/Text.config';
/* TYPES */
import type { TextsEmphasis, TextsTypes } from '@/types/texts/texts.types';

type Props = {
  type: TextsTypes;
  emphasis?: TextsEmphasis;
  tag?: 'span' | 'p' | 'div';
  fontColor?: string;
};

const props = withDefaults(defineProps<Props>(), {
  fontColor: 'text-fontPrimary'
});
/**
 * Get conf for this type
 */
const tagData: any = textConfig[props.type];
/**
 * Check what is enable and what is authorized
 */
const isUppercaseEnabled = props.emphasis && props.emphasis === 'uppercase' && tagData.uppercase;
const isItalicEnabled = props.emphasis && props.emphasis === 'italic' && tagData.italic;
const isLightEnabled = props.emphasis && props.emphasis === 'light' && tagData.light;
const isLightItalicEnabled = props.emphasis && props.emphasis === 'light-italic' && tagData.lightItalic;
const isRegularEnabled = props.emphasis && props.emphasis === 'regular' && tagData.regular;
const isMediumEnabled = props.emphasis && props.emphasis === 'medium' && tagData.medium;
const isBoldEnabled = props.emphasis && props.emphasis === 'bold' && tagData.bold;
const isThinEnabled = props.emphasis && props.emphasis === 'thin' && tagData.thin;
</script>

<template>
  <component
    :is="props.tag || tagData.tag"
    :class="[
      props.fontColor,
      tagData.class,
      isUppercaseEnabled ? 'text-uppercase' : '',
      isItalicEnabled ? 'font-italic' : '',
      isLightEnabled ? 'font-weight-light' : '',
      isThinEnabled ? 'font-weight-thin' : '',
      isLightItalicEnabled ? 'font-weight-light font-italic' : '',
      isRegularEnabled ? 'font-weight-regular' : '',
      isMediumEnabled ? 'font-weight-medium' : '',
      isBoldEnabled ? 'font-weight-bold' : ''
    ]"
  >
    <slot></slot>
  </component>
</template>
